module.exports = __webpack_public_path__ + "img/dashboard.ab15a9b9.png";